<template>
  <div>
    <div class="lable-group">
      <div class="firstLable">{{title | getTitle()}}</div>
      <el-radio-group @change="changeList" v-model="radio1">
        <el-row :gutter="2">
          <el-col :span="24/scheduleList.length" v-for="(i,index) in scheduleList" :key="index">
            <el-radio-button :label="index">{{i.dateDescription}}</el-radio-button>
          </el-col>
        </el-row>
      </el-radio-group>
    </div>
    <div class="table-list">
      <div
        v-for="(item,index) in tableList"
        :key="index"
        @mousemove="changeActive(index,$event)"
        class="table-item"
        :style="tableList.length < 4?'flex: 0 0 150px;':''"
        :class="active == index?'active':''"
      >
        <div v-if="active == index" @click="watchTV(item.id)">
          <p class="title-one">{{item.scheduleName.split("<&>")[0] || item.scheduleName}}</p>
          <p
            v-if="item.scheduleName.split('<&>')[1]"
            class="title-two"
          >{{item.scheduleName.split('<&>')[1] || ''}}</p>
          <p class="text-one">{{item.summary}}</p>
          <p class="time">
            <i class="el-icon-time"></i>
            {{item.scheduleTime}}
          </p>
          <div v-for="(o,p) in item.children" :key="p" class="guest-item">
            <!-- <div v-if="o.type"> -->
            <p v-if="o.type" class="title-group">{{o.type}}</p>
            <div v-for="(i,j) in o.arrList" :key="j" class="guest-item">
              <p class="title-three">{{i.scheduleName}}</p>
              <div v-for="(x,y) in i.guestList" :key="y" class="guest-item-list">
                <span class="text-two text-two-name" style>{{x.name}}</span>
                <span class="text-two">{{x.titles}}</span>
              </div>
            </div>
            <!-- </div> -->
            <!-- <div v-else>
              <p @click="watchTV(o.id,indexId,radio1)" class="title-three">{{o.scheduleName}}</p>
              <div v-for="(x,y) in o.guestList" :key="y" class="guest-item-list">
                <span class="text-two text-two-name" style>{{x.name}}</span>
                <span class="text-two">{{x.titles}}</span>
              </div>
            </div>-->
            <!-- <p @click="watchTV(i.id,indexId,radio1)" class="title-three">{{i.scheduleName}}</p>
            <div v-for="(x,y) in i.guestList" :key="y" class="guest-item-list">
              <span class="text-two text-two-name" style>{{x.name}}</span>
              <span class="text-two">{{x.titles}}</span>
            </div>-->
          </div>
        </div>
        <div
          v-else
          class="table-list-title"
        >{{item.scheduleName.split("<&>")[0] || item.scheduleName}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getToken } from "../utils/auth";
export default {
  props: {
    indexId: {
      type: Number,
      default: 0
    },
    scheduleList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    tableListData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    title: {
      type: Number,
      default: -1
    }
  },
  filters: {
    getTitle(val) {
      if (val == 1) {
        return "嵌入式物联网";
      } else if (val == 2) {
        return "工业物联网";
      } else {
        return "智慧城市";
      }
    }
  },
  computed: {},
  watch: {
    // tableListData(val) {
    //   this.tableList = val;
    // }
  },
  data() {
    return {
      active: 0,
      radio1: 0,
      tableList: this.tableListData,
      guestList: [],
      guestListShow: [],
      index: 12,
      data: {},
      partner: ""
    };
  },
  methods: {
    watchTV(id) {
      // 1 今日 2 回放  3 预告
      if (getToken()) {
        this.$c(this.$g.showScheduleOrMaterial, {
          id: id,
          type: "1"
        }).then(response => {
          if (response.code == 200) {
            if (response.success) {
              if (response.data.path) {
                this.$c(this.$g.getAssignUser, {
                  eid: localStorage.getItem("eid"),
                  url:
                    this.$i18n.locale == "zh"
                      ? response.data.path
                      : response.data.pathEn
                }).then(res => {
                  if (res.code == 200) {
                    window.open(res.data, "_blank");
                  }
                });
              } else {
                this.$message({
                  message: "该日程没有开放",
                  type: "error",
                  duration: 3 * 1000
                });
              }

              // this.Buriedpoint(targetType.AGENDA, id, type);
            } else {
              this.$message({
                message:
                  this.$i18n.locale == "zh"
                    ? response.message.split("/")[0]
                    : response.message.split("/")[1],
                type: "error",
                duration: 3 * 1000
              });
            }
          }
        });
      } else {
        this.$parent.$parent.centerDialogVisible = true;
      }
      // console.log(id, parentId);
      // this.$store.dispatch("setActiveSchedule", id);
      // this.$store.dispatch("setisWhatSchedule", parentId);
      // this.$store.dispatch("setisWhenSchedule", radio1);
      // sessionStorage.setItem("toId", id);
      // this.$router.push("/liveroom");
    },
    changeList(val) {
      this.tableList = this.scheduleList[val].event;

      this.active = 0;
    },
    changeActive(index, $event) {
      if (this.active != index) {
        this.active = index;
      }
    }
  },
  created() {
    this.scheduleList.map(p => {
      p.event.map(item => {
        let arr = [];
        let newList = [];
        if (item.children) {
          item.children.map(i => {
            if (i.cateName && arr.indexOf(i.cateName) < 0) {
              arr.push(i.cateName);
            }
          });
        }
        if (item.children) {
          arr.map(j => {
            let arrList = [];
            let obj = {};
            obj.type = j;
            item.children.map(i => {
              if (i.cateName) {
                if (j == i.cateName) {
                  arrList.push(i);
                }
              }
            });
            obj.arrList = arrList;
            newList.push(obj);
          });
        }
        if (newList.length > 0) {
          item.children = newList;
        } else {
          let arrList = [];
          let obj = {};
          obj.type = "";
          obj.arrList = item.children;
          newList.push(obj);
          item.children = newList;
        }
        return item;
      });
    });
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
@import "@/style/variable.less";
.table-list-title {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lable-group {
  display: flex;
  align-items: flex-end;
}
.firstLable {
  flex: 0 0 283px;
  width: 283px;
  height: 60px;
  line-height: 60px;
  background-color: #524e4e;
  text-align: center;
  border: 1px solid rgba(187, 187, 187, 1);
  box-sizing: border-box;
  color: rgba(255, 255, 255, 1);
  font-size: 21px;

  margin-right: 2px;
  position: relative;
}
.firstLable::after {
  position: absolute;
  right: 0;
  top: 0;
  width: 0;
  height: 0;
  border-color: red transparent;
  border-width: 50px 0 0 50px;
  border-style: solid;
}
.table-list {
  display: flex;
  border-top: 6px solid #17aaf0;
  // margin-top: 6px;
  .table-item {
    padding: 30px 10px 60px 20px;
    flex: 1;
    min-height: 380px;
    box-sizing: border-box;
    // width: 20%;
    // height: 100px;
    border: 1px solid rgba(184, 208, 240, 1);
    cursor: pointer;
    border-right: none;
    transition: all 0.5s;
    // -webkit-backface-visibility: hidden;
    // -webkit-transform-style: preserve-3d;
    &:last-child {
      border-right: 1px solid rgba(184, 208, 240, 1);
    }
    .title-one {
      color: @text-color;
      font-size: 21px;
      font-weight: bold;
    }
    .title-two {
      color: #5f7b9f;
      font-size: 16px;
      font-weight: bold;
      margin-top: 10px;
    }
    .title-three {
      color: @text-color;
      font-size: 16px;
      // font-weight: bold;
    }
    .title-group {
      font-size: 16px;
      margin-bottom: 8px;
      color: #fea302;
    }
    .text-one {
      color: rgba(147, 144, 144, 1);
      font-size: 14px;
      margin: 18px 0 18px 0;
    }
    .text-two {
      color: rgba(147, 144, 144, 1);
      font-size: 13px;
      display: inline-block;
    }
    .text-two-name {
      color: #222222;
      font-size: 14px;
      font-weight: bold;
      flex: 0 0 90px;
    }
    .time {
      color: #18aaf0;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 18px;
    }
    .guest-item {
      margin-bottom: 20px;
    }
    .guest-item-list {
      margin-top: 12px;
      display: flex;
    }
  }
  .active {
    // flex: 5;
    background-color: rgba(247, 249, 253, 1);
    flex: 0 0 600px !important;
    // transition: all 0.5s;
    // width: 40%;
  }
}
</style>